let audioContext: AudioContext | null = null;

/**
 * Petit "ding" à deux notes généré via Web Audio API plutôt qu'un fichier audio
 * à héberger — évite un asset supplémentaire pour un son aussi simple.
 * Les navigateurs bloquent l'audio tant qu'aucune interaction utilisateur n'a eu
 * lieu sur la page ; on avale l'erreur silencieusement dans ce cas (pas grave de
 * rater un ding, le badge non-lu prend le relais visuellement).
 */
export function playMessageNotificationSound(): void {
  try {
    audioContext ??= new AudioContext();
    if (audioContext.state === 'suspended') {
      void audioContext.resume();
    }

    const now = audioContext.currentTime;
    [880, 1320].forEach((frequency, index) => {
      const oscillator = audioContext!.createOscillator();
      const gain = audioContext!.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;

      const start = now + index * 0.1;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.15, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.25);

      oscillator.connect(gain);
      gain.connect(audioContext!.destination);
      oscillator.start(start);
      oscillator.stop(start + 0.25);
    });
  } catch {
    // Audio indisponible (permissions, navigateur) : on ignore silencieusement.
  }
}
